/**
 *  판매점 거절 타입 텍스트
 */
export const BRAND_REJECT_TYPE_TEXT = {
  0: '사업자 등록증',
  1: '통신판매업증',
  2: '통장사본',
  3: '공식홈페이지',
  4: '기타',
};

/**
 *  판매점 거절 타입 텍스트
 */
export const BRAND_REJECT_TYPE_CHECKBOX_LIST = [
  {
    id: 0,
    name: '사업자등록증',
  },
  {
    id: 1,
    name: '통신판매업증',
  },
  {
    id: 2,
    name: '통장사본',
  },
  {
    id: 3,
    name: '공식홈페이지',
  },
  {
    id: 4,
    name: '기타',
  },
];

/**
 *  판매자 SNS 타입
 */
export const BRAND_SNS_NUMBER = {
  INSTAGRAM: 1,
  FACEBOOK: 2,
  BLOG: 3,
};

/**
 *  판매점 상세 페이지 패널 name
 */
export const BRAND_DETAIL_PAGE_PANEL_NAME = {
  /**
   *  사업자 정보
   */
  BUSINESS: 'store-detail-info-business',
  /**
   *  정산 정보
   */
  BALANCE: 'store-detail-info-balance',
};

/**
 *  판매점 통계 타입 텍스트
 */
export const BRAND_DETAIL_CHART_CHECKBOX_LIST = [
  {
    id: 0,
    name: '브랜드 찜 수',
  },
  {
    id: 1,
    name: '브랜드 상세 페이지 조회 수',
  },
  {
    id: 2,
    name: '제품상세 유입',
  },
  {
    id: 3,
    name: '판매액',
  },
  {
    id: 4,
    name: '판매건수',
  },
];

/**
 *  판매점 이미지 업로드 수
 */
export const MAXIMUM_NUMBER_OF_STORE_ATTACHMENT = 1;

/**
 *  페이지 이름
 */
export const BRAND_PAGE_NAME = {
  BRAND_LIST: '브랜드 리스트',
  BRAND_TAG_REQUEST_LIST: '브랜드 태그 검수 리스트',
  BRAND_JOIN_REQUEST_LIST: '브랜드 입점 요청 리스트',
  BRAND_DETAIL: '브랜드 상세',
  BRAND_EDIT: '브랜드 편집',
  BRAND_TIER: '브랜드 티어관리',
  BRAND_TOP_EXPOSURE_LIST: '브랜드 상단 노출 관리',
  BRAND_EXPOSURE_LIST: '브랜드 노출 순서 관리',
};

/**
 *  페이지 타입
 */
export const BRAND_PAGE_TYPE = {
  DETAIL: 0,
  EDIT: 1,
  TOP_EXPOSURE: 2,
  EXPOSURE: 3,
};

/**
 *  브랜드 노출 상태 index
 */
export const BRAND_EXPOSURE_STATUS_INDEX_JSON = {
  IN_ACTIVE: 0,
  ACTIVE: 1,
};

/**
 *  브랜드 티어의 순서 값 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_TIER_ORDER_TEXT = 3;

/**
 *  브랜드 티어 리스트 상태
 */
export const BRAND_TIER_LIST_STATUS = {
  ADDED: 0,
  DELETED: 1,
  MODIFIED: 2,
  NORMAL: 3,
};

/**
 *  브랜드 티어 리스트 상태 텍스트
 */
export const BRAND_TIER_LIST_STATUS_CLASS_NAME = {
  0: 'added',
  1: 'deleted',
  2: 'modified',
  3: 'normal',
};

/**
 *  브랜드 노출 리스트 상태
 */
export const BRAND_EXPOSURE_LIST_STATUS = {
  ADDED: 0,
  DELETED: 1,
  MODIFIED: 2,
  NORMAL: 3,
};

/**
 *
 */
export const BRAND_EXPOSURE_LIST_STATUS_CLASS_NAME = {
  0: 'added',
  1: 'deleted',
  2: 'modified',
  3: 'normal',
};

/**
 *  판매점 리스트가 없을 때 보여주는 텍스트
 */
export const BRAND_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 판매점이 없습니다.';

/**
 *  브랜드 태그를 검수 할 브랜드 리스트가 없을 때 보여주는 텍스트
 */
export const BRAND_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT =
  '요청하신 검색 필터로 검색된 브랜드 태그를 검수 할 브랜드 리스트가 없습니다.';

/**
 *  판매점 상품 리스트가 없을 때 보여주는 텍스트
 */
export const BRAND_PRODUCT_LIST_TABLE_EMPTY_TEXT = '요청하신 상품 리스트가 없습니다.';

/**
 *  브랜드 리스트 검색 키워드 타입
 */
export const STORE_LIST_SEARCH_KEYWORD_TYPE = {
  /**
   *  브랜드
   */
  BRAND_NAME: 0,
  /**
   *  브랜드 ID
   */
  BRAND_ID: 1,
};

/**
 *  상점 상태
 */
export const STORE_STATUS = {
  /**
   *  승인 요청
   */
  REQUEST_JOIN: 0,
  /**
   *  승인 거절
   */
  REJECT: 1,
  /**
   *  활성화
   */
  ACTIVATE: 2,
  /**
   *  비활성화
   */
  INACTIVE: 3,
} as const;

/**
 *  상점 상태 텍스트
 */
export const STORE_STATUS_TEXT = {
  [STORE_STATUS.REQUEST_JOIN]: '가입 요청',
  [STORE_STATUS.REJECT]: '승인거절',
  [STORE_STATUS.ACTIVATE]: '활성',
  [STORE_STATUS.INACTIVE]: '비활성',
};

/**
 *  상점 상태 SELECT LIST
 */
export const STORE_STATUS_SELECT_LIST = [
  {
    id: STORE_STATUS.REQUEST_JOIN,
    name: STORE_STATUS_TEXT[STORE_STATUS.REQUEST_JOIN],
  },
  {
    id: STORE_STATUS.REJECT,
    name: STORE_STATUS_TEXT[STORE_STATUS.REJECT],
  },
  {
    id: STORE_STATUS.ACTIVATE,
    name: STORE_STATUS_TEXT[STORE_STATUS.ACTIVATE],
  },
  {
    id: STORE_STATUS.INACTIVE,
    name: STORE_STATUS_TEXT[STORE_STATUS.INACTIVE],
  },
];

/**
 *  판매점 활성 비활성 상태 SELECT 리스트
 */
export const STORE_ACTIVE_STATUS_SELECT_LIST = [
  {
    id: STORE_STATUS.ACTIVATE,
    name: STORE_STATUS_TEXT[STORE_STATUS.ACTIVATE],
  },
  {
    id: STORE_STATUS.INACTIVE,
    name: STORE_STATUS_TEXT[STORE_STATUS.INACTIVE],
  },
];

/**
 *  브랜드 리스트 검색 키워드 타입 텍스트
 */
export const STORE_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  [STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME]: '브랜드',
  [STORE_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID]: '브랜드 ID',
};

/**
 *  선택 가능한 브랜드 컨셉 태그 개수
 */
export const MAXIMUM_NUMBER_OF_STORE_CONCEPT_TAG = 3;

/**
 *  브랜드 태그 승인 거절 타입
 */
export const STORE_TAG_REJECT_TYPE = {
  /**
   *  브랜드 태그 부적합
   */
  INVALID_STORE_TAG: 0,
};

/**
 *  브랜드 태그 승인 거절 타입 텍스트
 */
export const STORE_TAG_REJECT_TYPE_TEXT = {
  /**
   *  브랜드 태그 부적합
   */
  [STORE_TAG_REJECT_TYPE.INVALID_STORE_TAG]: '브랜드 태그 부적합',
};

/**
 *  브랜드 태그 승인 거절 타입 SELECT 리스트
 */
export const STORE_TAG_REJECT_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: STORE_TAG_REJECT_TYPE.INVALID_STORE_TAG,
    name: STORE_TAG_REJECT_TYPE_TEXT[STORE_TAG_REJECT_TYPE.INVALID_STORE_TAG],
  },
];

/**
 *  브랜드 태그 승인 거절 사유 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_STORE_TAG_REJECT_REASON_TEXT = 700;

/**
 * 브랜드 상호/법인명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_COMPANY_NAME = 80;

/**
 *  판매처 타입
 */
export const BRAND_TYPE = {
  /**
   *  브랜드
   */
  BRAND: 0,
  /**
   *  아몬즈
   */
  AMONDZ: 1,
};

/**
 *  판매처 타입 텍스트
 */
export const BRAND_TYPE_TEXT = {
  /**
   *  브랜드
   */
  [BRAND_TYPE.BRAND]: '브랜드',
  /**
   *  아몬즈
   */
  [BRAND_TYPE.AMONDZ]: '아몬즈',
};

/**
 *  PB 브랜드 검색 타입
 */
export const PB_BRAND_SEARCH_TYPE = 3;

/**
 *  판매처 검색 타입
 */
export const BRAND_SEARCH_TYPE = {
  ...BRAND_TYPE,
  /**
   * PB 브랜드
   */
  PB: PB_BRAND_SEARCH_TYPE,
};

/**
 *  판매처 검색 타입 텍스트
 */
export const BRAND_SEARCH_TYPE_TEXT = {
  ...BRAND_TYPE_TEXT,
  [BRAND_SEARCH_TYPE.PB]: 'PB 브랜드',
};

/**
 *  판매처 검색 타입 SELECT LIST
 */
export const BRAND_SEARCH_TYPE_SELECT_LIST = [
  {
    id: BRAND_SEARCH_TYPE.BRAND,
    name: BRAND_SEARCH_TYPE_TEXT[BRAND_SEARCH_TYPE.BRAND],
  },
  {
    id: BRAND_SEARCH_TYPE.AMONDZ,
    name: BRAND_SEARCH_TYPE_TEXT[BRAND_SEARCH_TYPE.AMONDZ],
  },
  {
    id: BRAND_SEARCH_TYPE.PB,
    name: BRAND_SEARCH_TYPE_TEXT[BRAND_SEARCH_TYPE.PB],
  },
];

export const BRAND_BALANCE_PERIOD_INFO_TITLE_TEXT = {
  /**
   *  브랜드
   */
  [BRAND_TYPE.BRAND]: '브랜드상품',
  /**
   *  풀필먼트
   */
  [BRAND_TYPE.AMONDZ]: '풀필먼트상품',
};

export const MAIN_ADDRESS_LINE2_MAX_LENGTH = 255;

export const BRAND_TIER_LIST = [
  { id: 1, name: 1 },
  { id: 2, name: 2 },
  { id: 3, name: 3 },
];

/**
 * 브랜드 구분
 */
export const BRAND_PB_NB_TYPE = {
  PB: 'PB',
  NB: 'NB',
};
